import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import DatePicker from '../../../components/fields/DatePicker/DatePicker';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import ApplicationsDTO from '../../../dto/ApplicationsDTO';
import { createClearObject } from '../../../utils/utils';
import { PROCEDURE_TYPE_LIST } from '../../../configs';
import MultipleSelectInput from '../../../components/fields/SelectInput/MultipleSelectInput';

export default function FilterForm(props) {
  const {
    onHide, getValues, reset, defaultValues, meta, control,
  } = props;
  const { formatMessage } = useIntl();
  const DTO = new ApplicationsDTO();
  const attributes = DTO.getAttributesByName(false);
  const clear = () => {
    const fields = getValues();
    const cleared = createClearObject(fields);
    reset({ ...cleared, ...defaultValues });
  };
  const save = () => {
    onHide();
  };

  return (
    <Dialog
      className={classNames('full-filter')}
      onClose={save}
      open
    >
      <DialogTitle header={formatMessage({ id: 'filters' })} title={<Icons onClick={onHide} customIcon icon="close" className="close" />} />
      <DialogContent className="hff-content custom-scroll-theme">
        <form className="filter-content-wrapper">
          <FieldDTO
            control={control}
            component={MultipleSelectInput}
            dtoObject={attributes.procedures}
            hideSmallButtons
            placeholder="Форма подачи документов"
            showArrowIcon
            addPlaceholder
            usePortal
            withLabel
            variant="material"
            options={PROCEDURE_TYPE_LIST}
          />
          <FieldDTO
            control={control}
            component={DatePicker}
            dtoObject={attributes.created_at}
            hideSmallButtons
            showArrowIcon
            usePortal
            withLabel
            variant="material"
            changeFormat="YYYY-MM-DD"
          />
          <FieldDTO
            control={control}
            component={DatePicker}
            dtoObject={attributes.decided_at}
            hideSmallButtons
            showArrowIcon
            usePortal
            withLabel
            variant="material"
            changeFormat="YYYY-MM-DD"
          />
          <div>
            <FieldDTO
              control={control}
              component={DatePicker}
              dtoObject={attributes.decided_at}
              hideSmallButtons
              showArrowIcon
              usePortal
              withLabel
              variant="material"
              changeFormat="YYYY-MM-DD"
            />
            <FieldDTO
              control={control}
              component={DatePicker}
              dtoObject={attributes.decision_deadline_date}
              hideSmallButtons
              showArrowIcon
              usePortal
              withLabel
              variant="material"
              changeFormat="YYYY-MM-DD"
            />
            <FieldDTO
              control={control}
              component={CustomSelectInput}
              dtoObject={attributes.creator_id}
              hideSmallButtons
              showArrowIcon
              usePortal
              withLabel
              variant="material"
              options={[]}
            />
          </div>

        </form>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-text">{formatMessage({ id: 'find' })} {meta?.total} заявлений</div>
        <div className="hff-footer-buttons hff-center">
          <Button className="hff-clear-show" onClick={save}>{formatMessage({ id: 'show' })}</Button>
          <Button className="hff-clear-data" variant="secondary" onClick={clear}>{formatMessage({ id: 'clear.all' })}</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
